/** Shared rule keys; dependency-free because expiry and ability dispatch both import them. */
export const NEXT_SPELL_LAYERS = [
  'next_spell_aoe_changed_by_percentage', 'next_spell_aoe_effect_duplicated', 'next_spell_ap_override', 'next_spell_bounce_cast',
  'next_spell_concentration_uncapped', 'next_spell_damage_dice_changed_by_percentage', 'next_spell_damage_type_choice',
  'next_spell_hits_opposing_team_only', 'next_spell_paoe_applied_to_targets', 'next_spell_range_multiplier',
  'next_spell_self_range_becomes_reach', 'next_spell_target_opportunity_attack', 'next_spell_target_rider',
  'next_spell_twin_cast', 'next_spell_upcast_levels',
] as const;
